import type { Deal } from "./Deal";

type Mover = "company" | "vendor_company";

export type DealStatusReason = {
	dealId: number;
	id: string;
	mover: Mover;
	originStatusId: number;
	processed: boolean;
	reason: string;
	statusId: number;
};

export const getDealStatusBackReasons = (deal: Deal): DealStatusReason[] =>
	deal?.dealStatusReasons.filter((r: DealStatusReason) => !r.processed);
